import { AiFieldProposalFormValue } from "src/components/formFields/ai/utils/aiFieldProposalForm";
import { parseAiNamedOption, parseAiNumber, parseAiString } from "src/components/formFields/ai/utils/bindAiProposal";
import { AiFieldBinding, aiFieldBinding } from "src/components/formFields/ai/utils/reconcilePendingAiProposals";
import { Maybe } from "src/generated/graphqlTypes";
import { FieldState, ObjectState } from "src/utils/formState";
import { RoomFormValue, validateFullRoomNumber } from "./locationUtils";

/** The row's proposals paired with the form field each one writes to, for Accept All / Ignore All. */
export function roomProposalBindings(
  os: ObjectState<RoomFormValue>,
  levelName: string,
  fieldProposals: ObjectState<AiFieldProposalFormValue>[],
  roomTypes: readonly { id: string; name: string }[],
): AiFieldBinding[] {
  return [
    // Proposals carry the full room number (194), but the field stores the two-digit part (94).
    // Out-of-range proposals parse to undefined so Accept All rejects them without changing the room.
    aiFieldBinding(
      os.roomNumber as FieldState<Maybe<number>>,
      (raw) => {
        const full = parseAiNumber(raw);
        if (full === undefined) return undefined;
        const validated = validateFullRoomNumber(levelName, full);
        return "error" in validated ? undefined : validated.roomNumber;
      },
      fieldProposals.find((p) => p.fieldName.value === "roomNumber"),
    ),
    aiFieldBinding(
      os.roomTypeId as FieldState<Maybe<string>>,
      parseAiNamedOption(roomTypes),
      fieldProposals.find((p) => p.fieldName.value === "roomType"),
    ),
    aiFieldBinding(
      os.marketingName as FieldState<Maybe<string>>,
      parseAiString,
      fieldProposals.find((p) => p.fieldName.value === "marketingName"),
    ),
  ];
}
